import { FC, MouseEventHandler, useCallback, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { PlusIcon, SortByIcon } from 'assets/images/resourceCenter';
import { useStyles } from './MobileFilterMenu.styles';

export const MobileFilterMenu: FC = () => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <div className={styles.container}>
      <IconButton color="primary" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="mobile-filter-menu"
        anchorEl={anchorEl}
        open={open}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        onClose={handleClose}
        className={styles.menuContainer}
      >
        <MenuItem onClick={handleClose}>
          <span className={styles.titleButtonsQuickAccess}>Sort By</span>
          <img src={SortByIcon} alt="sort-icon" className={styles.sortByIcon} />
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <img src={PlusIcon} alt="plus-icon" className={styles.createNewFolderIcon} />
          <span className={styles.titleButtonsQuickAccess}>Create New Folder</span>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <span className={styles.titleButtonsQuickAccess}>Select</span>
        </MenuItem>
      </Menu>
    </div>
  );
};
